<template>
  <div id="appSettingsVueComponent" class="appFontBlack">
    <HeaderApp />
    <div class="appSettings">
      <h2>Paramètres</h2>
      <br>
          <button @click.prevent="goCollectionAdmin()" type="submit" class="appButtonModel2">Administrateur factures</button>
      <br>
      <br>
      <div class="settingDivFont">
        <h2>Modification de mot de passe</h2>
        <div class="appInputStyleMain">
          <label for="email" class="appLabelStyle1 appSettingsDeleteSpaces">Mon adresse mail</label>
          <input v-model="email" type="email" name="email" class="appInputStyle1" placeholder="">
        </div>
        <div class="appInputStyleMain">
          <label for="password1" class="appLabelStyle1 appSettingsDeleteSpaces">Mot de passe Actuel</label>
          <input v-model="password1" type="password" name="password1" class="appInputStyle1" placeholder="**********">
        </div>
        <div class="appInputStyleMain">
          <label for="password2" class="appLabelStyle1 appSettingsDeleteSpaces">Nouveau mot de passe</label>
          <input v-model="password2" type="password" name="password2" class="appInputStyle1" placeholder="**********">
        </div>
        <div class="appInputStyleMain">
          <label for="password3" class="appLabelStyle1 appSettingsDeleteSpaces">Confirmer le nouveau mot de passe</label>
          <input v-model="password3" type="password" name="password3" class="appInputStyle1" placeholder="**********">
        </div>
        <br>
        <button @click.prevent="ChangeLogin()" type="submit" class="appButtonModel2">Modifier mon mot de passe</button>
        <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
      </div>
      <br>
      <button @click.prevent="download_csv_All_BDD()" type="submit" class="appButtonModel2">Exporter toutes les
        BDD</button>
    </div>
    <FooterApp />
  </div>
</template>

<script>
import HeaderApp from '../Application/HeaderApp.vue'
import FooterApp from '../Application/FooterApp.vue'
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import axios from 'axios'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp,
    FooterApp
  },
  name: 'Settings',
  data () {
    return {
      email: '',
      password1: '',
      password2: '',
      password3: '',
      errorMsg: ''
    }
  },
  mounted () {
    document.getElementById('codeMode').innerText = JSON.parse(localStorage.getItem('modePrivilegia'))
  },
  methods: {
    download_csv_All_BDD () {
      if (window.confirm('Exporter toutes les Bases de données ?')) {
        this.download_csv_Articles()
        this.download_csv_Clients()
        this.download_csv_Dépenses()
        this.download_csv_Factures()
        this.download_csv_Produits()
        this.download_csv_Tarifs()
      }
    },
    download_csv_Articles () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/articles'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.article = response.data
          var myTotalCounter = this.article.length
          const globalArray = []
          // Ajouter entêtes
          const rowsNameArray = ['Code ID', 'UserID redacteur', 'Date', 'Titre', 'Description', 'Image']
          globalArray.push(rowsNameArray)
          // Ajouter contenus
          for (let myCounterArticle = 0; myCounterArticle < myTotalCounter; myCounterArticle++) {
            const ArticleArray = []
            ArticleArray.push(this.article[myCounterArticle]._id)
            ArticleArray.push(this.article[myCounterArticle].userId)
            ArticleArray.push(this.article[myCounterArticle].date)
            ArticleArray.push(this.article[myCounterArticle].title)
            ArticleArray.push(this.article[myCounterArticle].description)
            ArticleArray.push(this.article[myCounterArticle].imageUrl)
            globalArray.push(ArticleArray)
          }
          let csvContent = 'data:text/csv;charset=utf-8,'
          globalArray.forEach(function (rowArray) {
            let row = rowArray.join(';')
            csvContent += row + '\r\n'
          })
          var encodedUri = encodeURI(csvContent)
          var link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', 'BDD_Privilegia_Articles.csv')
          document.body.appendChild(link)
          link.click()
        })
    },
    download_csv_Clients () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/clients'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.client = response.data.sort(function tri (a, b) {
            if (a.firstname < b.firstname) { return -1 }
            if (a.firstname === b.firstname) { return 0 }
            if (a.firstname > b.firstname) { return 1 }
          })
          var myTotalCounter = this.client.length
          const globalArray = []
          // Ajouter entêtes
          const rowsNameArray = ['Code ID', 'Sexe', 'Nom', 'Prenom', 'Date naissance', 'Adresse', 'CP', 'Ville', 'Telephone', 'Mail', 'Notes', 'Fiches techniques']
          globalArray.push(rowsNameArray)
          // Ajouter contenus
          for (let myCounterClient = 0; myCounterClient < myTotalCounter; myCounterClient++) {
            const clientArray = []
            clientArray.push(this.client[myCounterClient]._id)
            clientArray.push(this.client[myCounterClient].sexe)
            clientArray.push(this.client[myCounterClient].firstname)
            clientArray.push(this.client[myCounterClient].lastname)
            clientArray.push(this.client[myCounterClient].birthdate)
            clientArray.push(this.client[myCounterClient].address)
            clientArray.push(this.client[myCounterClient].cp)
            clientArray.push(this.client[myCounterClient].city)
            clientArray.push(this.client[myCounterClient].phone)
            clientArray.push(this.client[myCounterClient].mail)
            clientArray.push(this.client[myCounterClient].notes)
            clientArray.push(this.client[myCounterClient].technicalsDatas.length)
            var myTotalCounterTechnicalsdatas = this.client[myCounterClient].technicalsDatas.length
            let clientDatasArray = []
            for (let myCounter = 0; myCounter < myTotalCounterTechnicalsdatas; myCounter++) {
              clientDatasArray.push(this.client[myCounterClient].technicalsDatas[myCounter].date)
              clientDatasArray.push(this.client[myCounterClient].technicalsDatas[myCounter].text)
              clientDatasArray.push(this.client[myCounterClient].technicalsDatas[myCounter].invoice)
            }
            clientArray.push(clientDatasArray)
            globalArray.push(clientArray)
          }
          let csvContent = 'data:text/csv;charset=utf-8,'
          globalArray.forEach(function (rowArray) {
            let row = rowArray.join(';')
            csvContent += row + '\r\n'
          })
          var encodedUri = encodeURI(csvContent)
          var link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', 'BDD_Privilegia_Clients.csv')
          document.body.appendChild(link)
          link.click()
        })
    },
    download_csv_Dépenses () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/depenses'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.spending = response.data
          var myTotalCounter = this.spending.length
          const globalArray = []
          // Ajouter entêtes
          const rowsNameArray = ['Code ID', 'UserID saisie', 'Date', 'Reference', 'Fournisseur', 'Categorie', 'Prix', 'Mode paiement']
          globalArray.push(rowsNameArray)
          // Ajouter contenus
          for (let myCounterSpending = 0; myCounterSpending < myTotalCounter; myCounterSpending++) {
            const SpendingArray = []
            SpendingArray.push(this.spending[myCounterSpending]._id)
            SpendingArray.push(this.spending[myCounterSpending].userId)
            SpendingArray.push(this.spending[myCounterSpending].date)
            SpendingArray.push(this.spending[myCounterSpending].reference)
            SpendingArray.push(this.spending[myCounterSpending].supplier)
            SpendingArray.push(this.spending[myCounterSpending].category)
            SpendingArray.push(this.spending[myCounterSpending].price)
            SpendingArray.push(this.spending[myCounterSpending].typeofpaiement)
            globalArray.push(SpendingArray)
          }
          let csvContent = 'data:text/csv;charset=utf-8,'
          globalArray.forEach(function (rowArray) {
            let row = rowArray.join(';')
            csvContent += row + '\r\n'
          })
          var encodedUri = encodeURI(csvContent)
          var link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', 'BDD_Privilegia_Depenses.csv')
          document.body.appendChild(link)
          link.click()
        })
    },
    download_csv_Factures () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/factures'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.invoice = response.data
          var myTotalCounter = this.invoice.length
          const globalArray = []
          // Ajouter entêtes
          const rowsNameArray = ['Code ID', 'UserID client', 'Date', 'Numero facture', 'Client', 'Reduction', 'Montant reduction', 'type paiement', 'Montant especes', 'Montant cheques', 'Montant CB', 'Montant Paylib', 'Montant Paypal', 'Prix total', 'Code facture', 'Fiche technique', 'Lignes']
          globalArray.push(rowsNameArray)
          // Ajouter contenus
          for (let myCounterInvoice = 0; myCounterInvoice < myTotalCounter; myCounterInvoice++) {
            const InvoiceArray = []
            InvoiceArray.push(this.invoice[myCounterInvoice]._id)
            InvoiceArray.push(this.invoice[myCounterInvoice].userId)
            InvoiceArray.push(this.invoice[myCounterInvoice].date)
            InvoiceArray.push(this.invoice[myCounterInvoice].number)
            InvoiceArray.push(this.invoice[myCounterInvoice].client)
            InvoiceArray.push(this.invoice[myCounterInvoice].reduction)
            InvoiceArray.push(this.invoice[myCounterInvoice].amountreduction)
            InvoiceArray.push(this.invoice[myCounterInvoice].typeofpaiement)
            InvoiceArray.push(this.invoice[myCounterInvoice].paiementEspeces)
            InvoiceArray.push(this.invoice[myCounterInvoice].paiementCheques)
            InvoiceArray.push(this.invoice[myCounterInvoice].paiementCB)
            InvoiceArray.push(this.invoice[myCounterInvoice].paiementPaylib)
            InvoiceArray.push(this.invoice[myCounterInvoice].paiementPaypal)
            InvoiceArray.push(this.invoice[myCounterInvoice].totalprice)
            InvoiceArray.push(this.invoice[myCounterInvoice].categoryOfInvoice)
            InvoiceArray.push(this.invoice[myCounterInvoice].technicalData)
            var myTotalCounterLines = this.invoice[myCounterInvoice].lines.length
            let linesDatasArray = []
            for (let myCounter = 0; myCounter < myTotalCounterLines; myCounter++) {
              linesDatasArray.push(this.invoice[myCounterInvoice].lines[myCounter].codeID)
              linesDatasArray.push(this.invoice[myCounterInvoice].lines[myCounter].category)
              linesDatasArray.push(this.invoice[myCounterInvoice].lines[myCounter].sexe)
              linesDatasArray.push(this.invoice[myCounterInvoice].lines[myCounter].size)
              linesDatasArray.push(this.invoice[myCounterInvoice].lines[myCounter].designation)
              linesDatasArray.push(this.invoice[myCounterInvoice].lines[myCounter].quantiy)
              linesDatasArray.push(this.invoice[myCounterInvoice].lines[myCounter].price)
              linesDatasArray.push(this.invoice[myCounterInvoice].lines[myCounter].total)
            }
            InvoiceArray.push(linesDatasArray)
            globalArray.push(InvoiceArray)
          }
          let csvContent = 'data:text/csv;charset=utf-8,'
          globalArray.forEach(function (rowArray) {
            let row = rowArray.join(';')
            csvContent += row + '\r\n'
          })
          var encodedUri = encodeURI(csvContent)
          var link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', 'BDD_Privilegia_Factures.csv')
          document.body.appendChild(link)
          link.click()
        })
    },
    download_csv_Produits () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/produits'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.product = response.data
          var myTotalCounter = this.product.length
          const globalArray = []
          // Ajouter entêtes
          const rowsNameArray = ['Code ID', 'Marque', 'Categorie', 'Nom', 'Prix achat', 'Prix vente', 'Quantite']
          globalArray.push(rowsNameArray)
          // Ajouter contenus
          for (let myCounterProducts = 0; myCounterProducts < myTotalCounter; myCounterProducts++) {
            const ProductArray = []
            ProductArray.push(this.product[myCounterProducts]._id)
            ProductArray.push(this.product[myCounterProducts].marque)
            ProductArray.push(this.product[myCounterProducts].category)
            ProductArray.push(this.product[myCounterProducts].name)
            ProductArray.push(this.product[myCounterProducts].priceBuyer)
            ProductArray.push(this.product[myCounterProducts].priceSeller)
            ProductArray.push(this.product[myCounterProducts].quantity)
            globalArray.push(ProductArray)
          }
          let csvContent = 'data:text/csv;charset=utf-8,'
          globalArray.forEach(function (rowArray) {
            let row = rowArray.join(';')
            csvContent += row + '\r\n'
          })
          var encodedUri = encodeURI(csvContent)
          var link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', 'BDD_Privilegia_Produits.csv')
          document.body.appendChild(link)
          link.click()
        })
    },
    download_csv_Tarifs () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/tarifs'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.tarif = response.data
          var myTotalCounter = this.tarif.length
          const globalArray = []
          // Ajouter entêtes
          const rowsNameArray = ['Code ID', 'Categorie', 'Nom', 'Prix unique', 'Prix S', 'Prix M', 'Prix L', 'Prix XL']
          globalArray.push(rowsNameArray)
          // Ajouter contenus
          for (let myCounterTarifs = 0; myCounterTarifs < myTotalCounter; myCounterTarifs++) {
            const TarifsArray = []
            TarifsArray.push(this.tarif[myCounterTarifs]._id)
            TarifsArray.push(this.tarif[myCounterTarifs].category)
            TarifsArray.push(this.tarif[myCounterTarifs].name)
            TarifsArray.push(this.tarif[myCounterTarifs].priceUnique)
            TarifsArray.push(this.tarif[myCounterTarifs].priceS)
            TarifsArray.push(this.tarif[myCounterTarifs].priceM)
            TarifsArray.push(this.tarif[myCounterTarifs].priceL)
            TarifsArray.push(this.tarif[myCounterTarifs].priceXL)
            globalArray.push(TarifsArray)
          }
          let csvContent = 'data:text/csv;charset=utf-8,'
          globalArray.forEach(function (rowArray) {
            let row = rowArray.join(';')
            csvContent += row + '\r\n'
          })
          var encodedUri = encodeURI(csvContent)
          var link = document.createElement('a')
          link.setAttribute('href', encodedUri)
          link.setAttribute('download', 'BDD_Privilegia_Tarifs.csv')
          document.body.appendChild(link)
          link.click()
        })
    },
    goCollectionAdmin () {
      this.$router.push('/App/Collection/Paiement/Admin')
    },
    ChangeLogin () {
      if (window.confirm('Modifier mon mot de passe?')) {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const decryptedToken = jwt_decode(tokenWithDatas.token)
        // Test si champs vides
        if ((this.email !== null || this.password1 !== null || this.password2 !== null || this.password3 === '') &&
          (this.password2 === this.password3)) {
          this.errorMsg = ''
          axios
            .put('https://privilegia.fr/api/users/' + decryptedToken.userId, {
              email: this.email,
              password: this.password1,
              password2: this.password2
            }, {
              headers: { Authorization: 'Bearer ' + tokenWithDatas.token }
            })
            .then((response) => {
              window.alert('Compte modifié')
              localStorage.removeItem('userPrivilegia')
              this.$router.push('/')
              location.reload()
            })
            .catch((error) => {
              console.log(error.response.data)
            })
        } else {
          this.errorMsg = 'Champs mal renseignés'
        }
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppSettings.vue